import React, { InputHTMLAttributes } from 'react'
import { classNames } from '../wrapper'
import { useNumberInput } from './useNumberInput'

const NumberNullable: React.FC<{
    value: number | null;
    change: (number: number | null) => void;
    children?: (attrs: InputHTMLAttributes<any>) => React.ReactNode
    fractionDigits?: number;
    onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
    error?: boolean;
    disabled?: boolean;
    className?: string;
}> = (props) => {
    const { last, onChange, onBlur } = useNumberInput(props.value, props.change, props.fractionDigits, true)

    if (props.children) {
        return <>
            {props.children({
                value: last,
                onBlur: () => onBlur(),
                onInput: (e) => onChange((e.target as HTMLInputElement).value)
            })}
        </>
    }

    return <input onPaste={e => props.onPaste?.(e)} className={classNames(props.className ,'input border', !!props.disabled ? 'bg-gray-200' : '',props.error ? 'border-error-300' : 'border-gray-300')} disabled={!!props.disabled} value={last} onBlur={() => onBlur()} onInput={(e) => onChange((e.target as HTMLInputElement).value)}/>
}

export default NumberNullable
